'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCrmObjectLifecycleUpdateMetadata = undefined;

var _objectTypes = require('../constants/objectTypes');

var _TicketUpdateMetadata = require('../records/TicketUpdateMetadata');

var _TicketUpdateMetadata2 = _interopRequireDefault(_TicketUpdateMetadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCrmObjectLifecycleUpdateMetadata = exports.buildCrmObjectLifecycleUpdateMetadata = function buildCrmObjectLifecycleUpdateMetadata(type, updateProps) {
  switch (type) {
    case _objectTypes.TICKET:
      return (0, _TicketUpdateMetadata2.default)(updateProps);
    default:
      return null;
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/crm-object-lifecycle-update/operators/buildCrmObjectLifecycleUpdateMetadata.js
// module id = 749
// module chunks = 2 3